import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../../utils/styles/theme';

interface Props {
  onClick: () => void;
  className?: string;
}

const Svg = styled.svg`
  border-radius: 50%;
  backdrop-filter: blur(8px);

  circle {
    fill: ${colors.concrete};
    fill-opacity: 0.2;
  }
`;

export default function SliderIcon({ onClick, className }: Props) {
  return (
    <Svg
      onClick={onClick}
      className={className}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className="circle" cx="28" cy="28" r="28" />
      <rect
        x="28.9453"
        y="21.334"
        width="1.99866"
        height="8.98247"
        transform="rotate(45 28.9453 21.334)"
        fill="white"
      />
      <rect
        x="30.3594"
        y="32.6387"
        width="1.99866"
        height="9.01354"
        transform="rotate(135 30.3594 32.6387)"
        fill="white"
      />
    </Svg>
  );
}
